import { BufferControllerEvents } from '@bufferController/BufferController.events';
import { IBufferMetrics, ITimeRange } from '@bufferController/BufferMetrics/IBufferMetrics';
import { IBufferStallsDetectorConfig } from '@bufferController/BufferStallsDetector/BufferStallsDetector.config';
import { ConfigConsumer } from '@configProvider/ConfigConsumer';
import { TEventBus } from '@eventBus/EventBus';
import bind from '@utils/decorators/bind';

export class BufferStallsDetector extends ConfigConsumer<IBufferStallsDetectorConfig> {
  private _isPrevCheckStalled: boolean = false;

  private readonly _onBufferMetricsAvailableListener: string;

  constructor(eventBus: TEventBus) {
    super('bufferStallsDetector', eventBus);

    this._onBufferMetricsAvailableListener = this._eventBus.subscribe(
      BufferControllerEvents.bufferMetricsAvailable,
      this._onBufferMetricsAvailable,
    );
  }

  @bind
  public destroy(): void {
    super.destroy();
    this._eventBus.unsubscribe(this._onBufferMetricsAvailableListener);
  }

  @bind
  public _handleConfigUpdated(): void {}

  @bind
  private _onBufferMetricsAvailable({ isStallCandidate, bufferedTimeRanges, currentPlaybackPosition }: IBufferMetrics): void {
    const lastBufferedTimeRange: ITimeRange | undefined = bufferedTimeRanges.slice(-1)[0];

    const bufferAmountToCurrentTimeRange: number = lastBufferedTimeRange ? lastBufferedTimeRange.end - currentPlaybackPosition : 0;
    const isActualStall: boolean = isStallCandidate && bufferAmountToCurrentTimeRange < this.config.bufferAmountToDetectStall;
    if (this._isPrevCheckStalled !== isActualStall) {
      this._isPrevCheckStalled = isActualStall;
      this._eventBus.publish(BufferControllerEvents.playbackStallChanged, isActualStall);
    }
  }
}
